import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ecf8f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-list-sim-card" }
const _hoisted_2 = { class: "sim-card-gb" }
const _hoisted_3 = { class: "sim-card-info" }
const _hoisted_4 = {
  key: 0,
  class: "esim-label"
}
const _hoisted_5 = {
  key: 1,
  class: "exp"
}
const _hoisted_6 = { class: "btn-group-card" }


import { Esim, EsimStatus, EsimType } from "@/stores/esim";
import { dateToString } from "@/helpers";
import BundleCountries from "@/components/bundle/BundleCountries.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EsimCard',
  props: {
  esim: Esim,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.esim)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["list-sim-card", { error: __props.esim?.expireSoon() && __props.esim?.type() !== _unref(EsimType).archive }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode(_toDisplayString(__props.esim.dataAmountGb()) + " GB ", 1),
              _createElementVNode("span", null, _toDisplayString(__props.esim.duration) + " days", 1)
            ]),
            _createVNode(BundleCountries, {
              countries: __props.esim?.bundleCountries() || [],
              "requested-countries": __props.esim.requestedCountries()
            }, null, 8, ["countries", "requested-countries"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (__props.esim.customLabel && __props.esim.customLabel.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.esim.customLabel), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["btn-new", {
            active: __props.esim?.status() === _unref(EsimStatus).active,
            archive: __props.esim?.status() === _unref(EsimStatus).archive,
          }])
            }, _toDisplayString(__props.esim.status() === _unref(EsimStatus).active
              ? "Active"
              : __props.esim.status() === _unref(EsimStatus).archive
              ? "Expired"
              : "New"), 3),
            (__props.esim?.expireSoon() && __props.esim?.type() !== _unref(EsimType).archive)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Exp. soon (" + _toDisplayString(_unref(dateToString)(__props.esim.expiresAt())) + ") ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "btn btn-act",
            to: `/esim/${__props.esim?.id}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Show details ")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})